module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Terminplan ro.9dc5bcb3.svg";